// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"dec814ef","456":"bb4bf7f3","715":"6f598c7b","724":"a6c90e63"}[chunkId] + ".chunk.js";
};